import { Locale } from '@formatjs/intl-utils/src/types';

const getEthicsLinks = (locale: Locale) => {
  if (locale === 'fr') {
    return 'https://glass-drill-c71.notion.site/Charte-thique-2a15e7c2b19e817b9461fa2d932bff2a';
  }

  return 'https://glass-drill-c71.notion.site/Ethical-charter-2a15e7c2b19e81f384f7fd26e9f812f3';
};

const getPrivacyLinks = (locale: Locale) => {
  if (locale === 'fr') {
    return 'https://glass-drill-c71.notion.site/Politique-de-confidentialit-des-donn-es-2a15e7c2b19e81059fe2e2f788360a1e';
  }

  return 'https://glass-drill-c71.notion.site/Privacy-Policy-2a15e7c2b19e8169871fcfc0a16baa4d';
};

const getTermsLinks = (locale: Locale) => {
  if (locale === 'fr') {
    return 'https://glass-drill-c71.notion.site/Conditions-g-n-rales-d-utilisation-2a15e7c2b19e81aaad5ee07061636702';
  }

  return 'https://glass-drill-c71.notion.site/Terms-of-Use-2a15e7c2b19e81a2bd16df719b7d6200';
};

const getFaqsLinks = (locale: Locale) => {
  if (locale === 'fr') {
    return 'https://glass-drill-c71.notion.site/Aide-2a15e7c2b19e8152ab45d74eefbc05d5';
  }

  return 'https://glass-drill-c71.notion.site/Help-center-2a15e7c2b19e81c8b238dd8688c31e16';
};

const getAccessibilityLinks = (locale: Locale) => {
  if (locale === 'fr') {
    return 'https://glass-drill-c71.notion.site/Accessibilit-2a15e7c2b19e81b98100df8034be6244';
  }

  return 'https://glass-drill-c71.notion.site/Accessibility-2a15e7c2b19e816887dec7a012125606';
};

export { getEthicsLinks, getPrivacyLinks, getTermsLinks, getFaqsLinks, getAccessibilityLinks };
